import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectGroup,
  SelectLabel,
} from '@/components/ui/select';
import { JurisdictionEnum, type IAgreementUpdateParams } from 'src/graphql/schema';

import { jurisdictionOptions as options } from '../model';

type Props = {
  onUpdate: (agreementParams: IAgreementUpdateParams) => void;
  jurisdiction?: JurisdictionEnum;
};

const AgreementJurisdictionSettings = ({ onUpdate, jurisdiction }: Props) => {
  const onUpdateAgreement = (jurisdiction: JurisdictionEnum) => onUpdate({ jurisdiction });

  return (
    <Select value={jurisdiction ?? ''} onValueChange={onUpdateAgreement}>
      <SelectTrigger className="w-full mb-2">
        <SelectValue placeholder="Select a jurisdiction" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Jurisdiction</SelectLabel>
          {options.map(({ label, value }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default AgreementJurisdictionSettings;
